<style>
    .collapse-a:before {
        font-family: "Font Awesome 5 Free";
        content: "\f067";
        margin-left: 10px
    }

    .collapse-a .collapse-a-title:before {
        content: "جزئیات بیشتر";
    }

    .collapse-a.lessDetails:before {
        font-family: "Font Awesome 5 Free";
        content: "\f068";
        margin-left: 10px
    }

    .collapse-a.lessDetails .collapse-a-title:before {
        content: "جزئیات کمتر";
    }

    .v-select ul li {
        padding: 10px 5px !important
    }
</style>
<template>
    <div id="page">
        <div class="page-content">
            <div class="page-title page-title-small">
                <h2><button @click.prevent="goBack"><i class="fa fa-arrow-right"></i></button>ثبت گفتگو جدید</h2>
                <button class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center refresh-btn" @click.prevent="reloadPage"><i class="font-16 fa fa-redo"></i></button>
                <button data-menu="menu-main" class="bg-fade-gray1-dark shadow-xl d-flex align-items-center justify-content-center menu-main-btn"><i class="fa fa-bars"></i></button>
            </div>
            <div class="card header-card shape-rounded" data-card-height="100">
                <div class="card-overlay bg-highlight opacity-95"></div>
                <div class="card-overlay dark-mode-tint"></div>
            </div>



            <div class="card card-style">
                <div class="content">
                    <div class="input-style input-style-2 has-icon input-required mb-3">
                        <i class="input-icon fa fa-user color-magenta2-light"></i>
                        <span class="color-highlight input-style-1-active">شماره</span>
                        <input class="form-control text-left" v-model="conversation.conversationNo" readonly type="text">
                    </div>

                    <div class="input-style input-style-2 has-icon input-required mb-3">
                        <i class="input-icon fa fa-user color-magenta2-light"></i>
                        <span class="color-highlight input-style-1-active">زمان</span>
                        <input class="form-control text-left" v-model="conversation.conversationDateTime" readonly type="text">
                    </div>

                    <div class="input-style input-style-2 has-icon input-required mb-3">
                        <i class="input-icon fa fa-user color-magenta2-light"></i>
                        <span class="color-highlight">موضوع</span>
                        <input class="form-control" @keyup="modified=true" v-model="conversation.subject" type="text">
                    </div>

                    <div class="mb-3">
                        <v-select dir="rtl" label="userTitle" placeholder="گیرندگان" multiple chips :options="OrgUnitUserList" :reduce="p => p.userId" v-model="conversation.users">
                            <template slot="option">
                                <div class="d-center">
                                    {{ option.userCode }}
                                </div>
                            </template>
                        </v-select>
                    </div>
                    <div class="card mx-0 mb-3">
                        <!--<div class="list-group list-custom-small list-icon-0 bg-blue1-dark px-2 collapse-description-box">
                            <button data-toggle="collapse" data-target="#collapse-description">
                                <i class="fa fa-edit mt-2"></i>
                                <span>متن</span>
                                <i class="fa fa-angle-down"></i>
                            </button>
                        </div>-->
                        <div>
                            <textarea v-model="conversation.description" @keyup="modified=true" class="form-control line-height-m text-justify rounded-sm" rows="3" style="height:200px" placeholder="متن پیام"></textarea>
                        </div>
                    </div>
                    <button class="btn btn-link speechToTextBtn mb-3" @pointerdown="startR"
                            @pointerup="stopR">
                        <span :class="btnRecord">
                            <span class="speechToTextBtn-text" v-if="showType">شروع به صحبت کنید...</span>
                        </span>
                        <img class="ml-3" v-if="showType" src="/assets/images/wave.gif" width="38" height="38" />
                    </button>
                    <att-list :docId="0" v-bind:destination="'Conversation'" @setAttList="SetAttList($event)" @attInProgress="AttInProgress($event)" :canAdd="true" :canDelete="true" :oldAttList="[]" :hasLocation="false"></att-list>

                    <div class="collapse pt-3" id="collapse-moreDetails">
                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="conversation.personId" label="title" @option:selected="onchangePerson" placeholder="شخص/شرکت" :filter="PersonFilter" :options="PersonList" :reduce="p => p.personId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                {{ option.title }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="conversation.projectId" label="fullTitle" @option:selected="onchangeProject" placeholder="پروژه" :filter="ProjectFilter" :options="ProjectList" :reduce="p => p.projectId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                {{ option.fullTitle }}
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="conversation.preInvoiceId" label="strDocNo" @option:selected="onchangePreInvoice" placeholder=" پیش فاکتور فروش کالا/خدمات" :filter="PreInvoiceFilter" :options="PreInvoiceList" :reduce="p => p.preInvoiceId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="conversation.contractId" label="strDocNo" @option:selected="onchangeContract" placeholder="قرارداد" :filter="ContractFilter" :options="ContractList" :reduce="p => p.contractId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="conversation.meetingId" label="strDocNo" @option:selected="onchangeMeeting" placeholder="جلسه" :filter="MeetingFilter" :options="MeetingList" :reduce="p => p.meetingId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="!isMinVersion">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="conversation.letterId" label="strDocNo" @option:selected="onchangeLetter" placeholder="نامه" :filter="LetterFilter" :options="LetterList" :reduce="p => p.letterId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="conversation.invoiceId" label="strDocNo" @option:selected="onchangeInvoice" placeholder="فاکتور فروش کالا/خدمات" :filter="InvoiceFilter" :options="InvoiceList" :reduce="p => p.invoiceId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>




                        <div class="mb-3" v-if="(!isMinVersion) && HasCom">
                            <div class="d-flex">
                                <div class="w-100">
                                    <v-select dir="rtl" v-model="conversation.buyId" label="strDocNo" @option:selected="onchangeBuy" placeholder="خرید کالا/خدمات" :filter="BuyFilter" :options="BuyList" :reduce="p => p.buyId">
                                        <template v-slot="option">
                                            <div class="d-center">
                                                <span>{{  option.strDocNo }}</span>
                                            </div>
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="mb-3">
                            <!--@option:cleared="ChangeWorkGroup"-->
                            <v-select dir="rtl" label="title" placeholder="کارگروه" :filterable="WorkGroupList.length>10" :searchable="WorkGroupList.length>10" :options="WorkGroupList" :reduce="p => p.workGroupId" v-model="conversation.workGroupId" @option:selected="onChangeWorkGroup">
                                <template slot="option">
                                    <div class="d-center">
                                        {{ option.title }}
                                    </div>
                                </template>
                            </v-select>
                        </div>

                    </div>
                    <button data-toggle="collapse" data-target="#collapse-moreDetails" class="btn btn-xxs mb-3 btn-full rounded-sm bg-highlight font-900 collapse-a w-100" id="moreLessDetails" @click="toggleClasslessDetails()">
                        <span class="collapse-a-title"></span>
                    </button>


                    <div>
                        <button :disabled="pageLoading || attInProgress" class="btn btn-xxs mt-2 btn-full bg-green1-dark rounded-sm font-900 w-100 btn_checkSmsm" @click.prevent="CreateConversation">
                            <i class="fa fa-check font-10 ml-2"></i>
                            ثبت
                        </button>
                    </div>
                </div>
                <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOutDown">
                    <div v-if="pageLoading" class="w-100 d-flex justify-content-center loadingBox">
                        <div class="toast-tiny toast-bottom bg-magenta1-light fade show text-center font-10"><i class="fa fa-sync fa-spin ml-3"></i>لطفا صبر کنید ...</div>
                    </div>
                </transition>
            </div>
        </div>
    </div>
</template>
<script>
    import {
        required
    } from "@vuelidate/validators";
    import 'vue-select/dist/vue-select.css';
    import { maska } from 'maska'
    import AttList from '../Components/AttList.vue';
    import VueSimpleAlert from 'vue3-simple-alert';
    const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition
    export default {
        components: {
            "att-list": AttList
        },
        data() {

            return {
                pageLoading: false,
                attInProgress: false,
                showType: false,
                modified: false,
                sr: null,
                btnRecord: "btn btn-danger speechToTextBtn-i",
                conversation: {
                    conversationId: 0,
                    conversationDateTime: "",
                    conversationNo: "",
                    subject: "",
                    description: "",
                    userId: 0,
                    userTitle: "",
                    workGroupTitle: "",
                    taskFolderId: null,
                    taskFolderTitle: "",

                    strUserId: "",
                    createDateTime: "",
                    closeDateTime: "",
                    updateDateTime: "",
                    conversationFolders: [],
                    users: [],
                    folderDescription: "",
                    strUserTitle: "",
                    taskId: null,
                    taskDate: "",
                    taskTitle: "",
                    hasNewFolder: false,
                    conversationAttJson: "",
                    closeAfterCreate: false,

                    docAtts: [],
                    attJson: "",





                    workGroupId: null,
                    projectId: null,
                    invoiceId: null,
                    preInvoiceId: null,
                    contractId: null,
                    letterId: null,
                    personId: null,
                    meetingId: null,
                    preBuyInvoiceId: null,
                    buyId: null,

                    projectTitle: null,
                    preInvoiceTitle: null,
                    invoiceTitle: null,
                    letterTitle: null,
                    buyTitle: null,
                    contractTitle: null,
                    personTitle: null,
                    meetingTitle: null,
                    preBuyInvoiceTitle: null,
                    leadTitle: null,
                }
            }
        },
        watch: {
            'conversation.workGroupId'(value) {
                this.onChangeWorkGroup();
            },
            'conversation.personId'(value) {
                this.onchangePerson();
            },
            'conversation.projectId'(value) {
                this.onchangeProject();
            },
            'conversation.preInvoiceId'(value) {
                this.onchangePreInvoice();
            },
            'conversation.contractId'(value) {
                this.onchangeContract();
            },
            'conversation.meetingId'(value) {
                this.onchangeMeeting();
            },
            'conversation.invoiceId'(value) {
                this.onchangeInvoice();
            },
            'conversation.letterId'(value) {
                this.onchangeLetter();
            },
            'conversation.buyId'(value) {
                this.onchangeBuy();
            }

        },
        created() {
            this.$store.dispatch("GetPersonListFromServer", {});
            this.$store.dispatch("GetProjectListFromServer", {});
            this.$store.dispatch("GetOrgUnitUserList", {});
            this.$store.dispatch("GetPreInvoiceAbstractForPerson", {});
            this.$store.dispatch("GetContractAbstractForPerson", {});
            this.$store.dispatch("GetInvoiceAbstractForPerson", {});
            this.$store.dispatch("GetLetterAbstractForPerson", {});
            this.$store.dispatch("GetMeetingAbstractForPerson", {});
            this.$store.dispatch("GetBuyAbstractForPerson", {});
            this.$store.dispatch("GetWorkGroupListFromServer", {});
            this.GetConversationDateTime();
            this.GetConversationNo();
        },
        methods: {
            CreateConversation() {
                this.pageLoading = true;
                if (this.conversation.description != null && this.conversation.description != '') {
                    this.$http.post("Conversation/CreateConversation", this.conversation)
                        .then(data => {
                            this.pageLoading = false;
                            var res = data.data;
                            if (res.isSuccess) {
                                this.modified = false;
                                this.showSuccessMessage(res.message);
                                setTimeout(function () { window.location = '/ConversationEdit/' + res.obj; }, 1500);
                            } else {
                                this.showErrorMessage(res.message);
                            }
                        });
                }
            },
            startR() {
                try {
                    this.sr.start();
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                } catch (error) {
                    console.error(error);
                    this.showType = true;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }

            },
            stopR() {
                try {
                    this.sr.stop();
                    this.showType = false;
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                } catch (error) {
                    console.error(error);
                    this.showType = false;
                    // Expected output: ReferenceError: nonExistentFunction is not defined
                    // (Note: the exact output may be browser-dependent)
                }
            },
            SetAttList(e) {
                console.log(e);
                this.conversation.docAtts = e;
            },
            AttInProgress(e) {
                this.attInProgress = e;
            },
            GetConversationNo() {
                this.pageLoading = true;
                this.$http.get("Conversation/GetConversationNo")
                    .then((data) => {
                        this.conversation.conversationNo = data.data.toString();
                        this.pageLoading = false;
                    });
            },
            GetConversationDateTime() {
                this.pageLoading = true;
                this.$http.get("Conversation/GetConversationDateTime")
                    .then((data) => {
                        this.conversation.conversationDateTime = data.data;
                        this.pageLoading = false;
                    });
            },
            PersonFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetPersonListFromServer", {
                        text: queryText,
                    });
                return this.$store.getters.GetPersonList;
            },
            onchangePerson() {
                this.conversation.projectId = null;
                this.conversation.invoiceId = null;
                this.conversation.preInvoiceId = null;
                this.conversation.contractId = null;
                this.conversation.letterId = null;
                this.conversation.meetingId = null;
                this.conversation.preBuyInvoiceId = null;
                this.conversation.buyId = null;
                this.$store.dispatch("GetProjectListFromServer", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetContractAbstractForPerson", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetLetterAbstractForPerson", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.conversation.personId,
                });
            },


            ProjectFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetProjectListFromServer", {
                        text: queryText,
                        personId: this.conversation.personId,
                    });
                return this.$store.getters.GetProjectList;
            },
            onchangeProject() {
                this.conversation.contractId = null;
                this.conversation.meetingId = null;
                this.$store.dispatch("GetContractAbstractForPerson", {
                    text: "",
                    personId: this.conversation.personId,
                    projectId: this.conversation.projectId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.conversation.personId,
                    projectId: this.conversation.projectId,
                });
            },


            PreInvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetPreInvoiceAbstractForPerson", {
                        text: queryText,
                        personId: this.conversation.personId,
                        projectId: this.conversation.projectId,
                    });
                return this.$store.getters.GetPreInvoiceList;
            },
            onchangePreInvoice() {
                //this.conversation.contractId = null;
                this.conversation.invoiceId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.conversation.preInvoiceId,
                    contractId: this.conversation.contractId,
                    personId: this.conversation.personId,
                });
            },



            ContractFilter(item, queryText, itemText) {
                if (queryText.length > 3)
                    this.$store.dispatch("GetContractAbstractForPerson", {
                        text: queryText,
                        personId: this.conversation.personId,
                    });
                return this.$store.getters.GetContractList;
            },
            onchangeContract() {
                this.conversation.invoiceId = null;
                this.conversation.buyId = null;
                this.conversation.meetingId = null;
                this.$store.dispatch("GetInvoiceAbstractForPerson", {
                    text: "",
                    preInvoiceId: this.conversation.preInvoiceId,
                    contractId: this.conversation.contractId,
                    personId: this.conversation.personId,
                });
                this.$store.dispatch("GetMeetingAbstractForPerson", {
                    personId: this.conversation.personId,
                    projectId: this.conversation.projectId,
                    contractId: this.conversation.contractId,
                });
                this.$store.dispatch("GetBuyAbstractForPerson", {
                    personId: this.conversation.personId,
                    prebuyInvoiceId: this.conversation.prebuyInvoiceId,
                    contractId: this.conversation.contractId,
                });

            },



            InvoiceFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetInvoiceAbstractForPerson", {
                        text: queryText,
                        preInvoiceId: this.conversation.preInvoiceId,
                        contractId: this.conversation.contractId,
                        personId: this.conversation.personId,
                    });
                return this.$store.getters.GetInvoiceList;
            },
            onchangeInvoice() {
                console.log("")
            },



            LetterFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetLetterAbstractForPerson", {
                        text: queryText,
                        personId: this.conversation.personId,
                    });
                return this.$store.getters.GetLetterList;
            },
            onchangeLetter() {
                console.log("")
            },



            MeetingFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetMeetingAbstractForPerson", {
                        text: queryText,
                        personId: this.conversation.personId,
                        contractId: this.conversation.contractId,
                        projectId: this.conversation.projectId,
                    });
                return this.$store.getters.GetMeetingList;
            },
            onchangeMeeting() {
                console.log("")
            },

            BuyFilter(item, queryText, itemText) {
                if (queryText.length > 0)
                    this.$store.dispatch("GetBuyAbstractForPerson", {
                        text: queryText,
                        personId: this.conversation.personId,
                        prebuyInvoiceId: this.conversation.prebuyInvoiceId,
                        contractId: this.conversation.contractId,
                    });
                return this.$store.getters.GetBuyList;
            },
            onchangeBuy() {
                console.log("")
            },




            onChangeWorkGroup() {
                this.conversation.userId = null;
                this.$store.dispatch("GetLocalUserListListFromServer", {
                    workGroupId: this.conversation.workGroupId
                });
            },
            toggleClasslessDetails() {
                var element = document.getElementById("moreLessDetails");
                element.classList.toggle("lessDetails");
            },
        },
        computed: {
            OrgUnitUserList() {
                return this.$store.getters.GetOrgUnitUserList;
            },

            PersonList() {
                return this.$store.getters.GetPersonList;
            },
            ProjectList() {
                return this.$store.getters.GetProjectList;
            },
            PreInvoiceList() {
                return this.$store.getters.GetPreInvoiceList;
            },
            ContractList() {
                return this.$store.getters.GetContractList;
            },
            InvoiceList() {
                return this.$store.getters.GetInvoiceList;
            },
            LetterList() {
                return this.$store.getters.GetLetterList;
            },
            MeetingList() {
                return this.$store.getters.GetMeetingList;
            },
            PreBuyInvoiceList() {
                return this.$store.getters.GetPreBuyInvoiceList;
            },
            BuyList() {
                return this.$store.getters.GetBuyList;
            },
            LocalUserListForMention() {
                return this.$store.getters.GetLocalUserListForMention;
            },
            WorkGroupList() {
                return this.$store.getters.GetWorkGroupList;
            },
            HasCom() {
                return this.$store.getters.GetHasCom;
            },
        },
        mounted() {
            this.pageLoading = false;
            try {
                this.sr = new Recognition()
                this.sr.continuous = true
                this.sr.interimResults = true
                this.sr.lang = 'fa-IR';
                var rest = "";
                this.sr.onstart = () => {
                    this.showType = true;
                    this.btnRecord = "btn btn-success speechToTextBtn-i-L";
                }
                this.sr.onresult = (evt) => {
                    rest = evt.results[evt.results.length - 1][0].transcript;
                }
                this.sr.onend = () => {
                    rest = rest.replaceAll("علامت سوال", "؟");
                    rest = rest.replaceAll("علامت تعجب", "!");
                    rest = rest.replaceAll("علامت بزرگتر", ">");
                    rest = rest.replaceAll("علامت کوچکتر", "<");
                    rest = rest.replaceAll("پرانتز باز", "(");
                    rest = rest.replaceAll("پرانتز بسته", ")");
                    rest = rest.replaceAll("شارپ", "#");
                    rest = rest.replaceAll("ستاره", "*");
                    rest = rest.replaceAll("دو نقطه", ": ");
                    rest = rest.replaceAll("نقطه ویرگول", "; ");
                    rest = rest.replaceAll("نقطه", ". ");


                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("پاراگراف جدید", "\n");
                    rest = rest.replaceAll("پاراگراف بعد", "\n");
                    rest = rest.replaceAll("پاراگراف بعدی", "\n");
                    rest = rest.replaceAll("پاراگراف", "\n");
                    rest = rest.replaceAll("اینتر", "\n");
                    rest = rest.replaceAll("خط بعدی", "\n");
                    rest = rest.replaceAll("خط بعد", "\n");
                    rest = rest.replaceAll("خط جدید", "\n");

                    if (this.conversation.description == null || this.conversation.description == "null")
                        this.conversation.description = "";
                    if (rest != null && rest != '')
                        this.conversation.description = this.conversation.description + " " + rest
                    this.btnRecord = "btn btn-danger speechToTextBtn-i";
                    rest = "";
                    this.showType = false;
                }
            } catch (error) {
                console.error(error);
            }
        },
        beforeRouteLeave(to, from, next) {
            if (this.modified == true) {
                VueSimpleAlert.fire({
                    title: 'با بستن این صفحه تغییرات شما ذخیره نخواهد شد. آیا ادامه می دهید؟',
                    showCancelButton: true,
                    confirmButtonText: 'تأیید',
                    cancelButtonText: `انصراف`,
                }).then((result) => {
                    console.log(this.modified);

                    if (result.value == true) {
                        next();
                    } else {
                        next(false);
                    }
                })
            }
            else {
                next();
            }
        }
    }
</script>